module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/6-5f673dbf3aa04a0cca5100abccd604a3.jpg";